import styled from 'styled-components';

const MenuButton = styled.div`
  cursor: pointer;
  padding: 10px 5px;

  &:hover {
    opacity: 0.5;
  }
`;

export default MenuButton;
